import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = 'https://sistemafinanciero.digitaleseduproperu.com/api';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const TIPOS = [
  { value: 'normal',   label: 'Normal',   color: 'success' },
  { value: 'tardanza', label: 'Tardanza', color: 'warning' },
  { value: 'falta',    label: 'Falta',    color: 'danger' },
  { value: 'permiso',  label: 'Permiso',  color: 'info' },
  { value: 'feriado',  label: 'Feriado',  color: 'secondary' },
];

export default function AsistenciaPage() {
  const hoy = new Date();
  const [vista, setVista] = useState('masivo'); // masivo | historial | resumen
  const [empleados, setEmpleados] = useState([]);
  const [historial, setHistorial] = useState([]);
  const [resumen, setResumen] = useState([]);
  const [fecha, setFecha] = useState(hoy.toISOString().substring(0, 10));
  const [mes, setMes] = useState(hoy.getMonth() + 1);
  const [anio, setAnio] = useState(hoy.getFullYear());
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { cargarEmpleados(); }, []);
  useEffect(() => { if (vista === 'historial') cargarHistorial(); }, [vista, mes, anio]);
  useEffect(() => { if (vista === 'resumen') cargarResumen(); }, [vista, mes, anio]);

  const cargarEmpleados = async () => {
    try {
      const res = await axios.get(`${API}/empleados`, {
        headers: headers(), params: { estado: 'activo' }
      });
      setEmpleados(res.data);
      setRegistros(res.data.map(e => ({
        empleado_id:  e.id,
        nombre:       `${e.apellidos}, ${e.nombres}`,
        cargo:        e.cargo || '—',
        hora_entrada: '08:00',
        hora_salida:  '17:00',
        tipo:         'normal',
        observacion:  '',
      })));
    } catch (e) { console.error(e); }
  };

  const cargarHistorial = async () => {
    try {
      const res = await axios.get(`${API}/asistencia`, {
        headers: headers(), params: { mes, anio }
      });
      setHistorial(res.data);
    } catch (e) { console.error(e); }
  };

  const cargarResumen = async () => {
    try {
      const res = await axios.get(`${API}/asistencia/resumen-mensual`, {
        headers: headers(), params: { mes, anio }
      });
      setResumen(res.data);
    } catch (e) { console.error(e); }
  };

  const actualizarRegistro = (idx, campo, valor) => {
    setRegistros(prev => prev.map((r, i) => i === idx ? { ...r, [campo]: valor } : r));
  };

  const guardarMasivo = async () => {
    setLoading(true); setMsg('');
    try {
      await axios.post(`${API}/asistencia/masivo`,
        { fecha, registros },
        { headers: headers() }
      );
      setMsg('✅ Asistencia guardada correctamente.');
    } catch (e) {
      setMsg('❌ Error al guardar asistencia.');
    } finally { setLoading(false); }
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar este registro?')) return;
    try {
      await axios.delete(`${API}/asistencia/${id}`, { headers: headers() });
      cargarHistorial();
    } catch (e) { console.error(e); }
  };

  const tipoBadge = (tipo) => {
    const t = TIPOS.find(x => x.value === tipo);
    return <span className={`badge bg-${t?.color || 'secondary'}`}>{t?.label || tipo}</span>;
  };

  const meses = [
    'Enero','Febrero','Marzo','Abril','Mayo','Junio',
    'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
  ];

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold mb-0">
          <i className="fas fa-calendar-check me-2 text-primary"></i>Asistencia
        </h2>
        <div className="btn-group">
          <button className={`btn ${vista==='masivo'?'btn-primary':'btn-outline-primary'}`}
            onClick={() => setVista('masivo')}>
            <i className="fas fa-edit me-1"></i>Registro Diario
          </button>
          <button className={`btn ${vista==='historial'?'btn-primary':'btn-outline-primary'}`}
            onClick={() => setVista('historial')}>
            <i className="fas fa-list me-1"></i>Historial
          </button>
          <button className={`btn ${vista==='resumen'?'btn-primary':'btn-outline-primary'}`}
            onClick={() => setVista('resumen')}>
            <i className="fas fa-chart-bar me-1"></i>Resumen
          </button>
        </div>
      </div>

      {/* REGISTRO MASIVO */}
      {vista === 'masivo' && (
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Registro de Asistencia Diaria</h5>
            <div className="d-flex align-items-center gap-3">
              <div>
                <label className="me-2 fw-semibold">Fecha:</label>
                <input type="date" className="form-control d-inline-block w-auto"
                  value={fecha} onChange={e => setFecha(e.target.value)} />
              </div>
              <button className="btn btn-success" onClick={guardarMasivo} disabled={loading}>
                <i className="fas fa-save me-1"></i>
                {loading ? 'Guardando...' : 'Guardar Todo'}
              </button>
            </div>
          </div>
          <div className="card-body">
            {msg && <div className={`alert ${msg.includes('✅')?'alert-success':'alert-danger'}`}>{msg}</div>}
            {empleados.length === 0
              ? <p className="text-muted text-center py-3">No hay empleados activos.</p>
              : <div className="table-responsive">
                  <table className="table table-sm table-hover">
                    <thead className="table-light">
                      <tr>
                        <th>Empleado</th>
                        <th>Cargo</th>
                        <th style={{width:110}}>Entrada</th>
                        <th style={{width:110}}>Salida</th>
                        <th style={{width:130}}>Tipo</th>
                        <th>Observación</th>
                      </tr>
                    </thead>
                    <tbody>
                      {registros.map((r, idx) => (
                        <tr key={r.empleado_id}>
                          <td className="fw-semibold">{r.nombre}</td>
                          <td><small className="text-muted">{r.cargo}</small></td>
                          <td>
                            <input type="time" className="form-control form-control-sm"
                              value={r.hora_entrada}
                              disabled={r.tipo === 'falta' || r.tipo === 'feriado'}
                              onChange={e => actualizarRegistro(idx, 'hora_entrada', e.target.value)} />
                          </td>
                          <td>
                            <input type="time" className="form-control form-control-sm"
                              value={r.hora_salida}
                              disabled={r.tipo === 'falta' || r.tipo === 'feriado'}
                              onChange={e => actualizarRegistro(idx, 'hora_salida', e.target.value)} />
                          </td>
                          <td>
                            <select className="form-select form-select-sm" value={r.tipo}
                              onChange={e => actualizarRegistro(idx, 'tipo', e.target.value)}>
                              {TIPOS.map(t => (
                                <option key={t.value} value={t.value}>{t.label}</option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <input className="form-control form-control-sm" value={r.observacion}
                              placeholder="Opcional..."
                              onChange={e => actualizarRegistro(idx, 'observacion', e.target.value)} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
            }
          </div>
        </div>
      )}

      {/* HISTORIAL */}
      {vista === 'historial' && (
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Historial de Asistencia</h5>
            <div className="d-flex gap-2">
              <select className="form-select w-auto" value={mes}
                onChange={e => setMes(e.target.value)}>
                {meses.map((m, i) => (
                  <option key={i+1} value={i+1}>{m}</option>
                ))}
              </select>
              <input type="number" className="form-control w-auto" value={anio}
                onChange={e => setAnio(e.target.value)} style={{width:90}} />
            </div>
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Fecha</th>
                    <th>Empleado</th>
                    <th>Cargo</th>
                    <th>Entrada</th>
                    <th>Salida</th>
                    <th>Tipo</th>
                    <th>Observación</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {historial.length === 0
                    ? <tr><td colSpan={8} className="text-center py-4 text-muted">
                        No hay registros para este período.
                      </td></tr>
                    : historial.map(r => (
                      <tr key={r.id}>
                        <td>{r.fecha?.substring(0,10)}</td>
                        <td className="fw-semibold">{r.empleado_nombre}</td>
                        <td><small className="text-muted">{r.cargo}</small></td>
                        <td>{r.hora_entrada || '—'}</td>
                        <td>{r.hora_salida || '—'}</td>
                        <td>{tipoBadge(r.tipo)}</td>
                        <td><small>{r.observacion || '—'}</small></td>
                        <td>
                          <button className="btn btn-sm btn-outline-danger"
                            onClick={() => eliminar(r.id)}>
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* RESUMEN */}
      {vista === 'resumen' && (
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Resumen Mensual</h5>
            <div className="d-flex gap-2">
              <select className="form-select w-auto" value={mes}
                onChange={e => setMes(e.target.value)}>
                {meses.map((m, i) => (
                  <option key={i+1} value={i+1}>{m}</option>
                ))}
              </select>
              <input type="number" className="form-control w-auto" value={anio}
                onChange={e => setAnio(e.target.value)} style={{width:90}} />
            </div>
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Código</th>
                    <th>Empleado</th>
                    <th>Cargo</th>
                    <th className="text-center text-success">Normales</th>
                    <th className="text-center text-warning">Tardanzas</th>
                    <th className="text-center text-danger">Faltas</th>
                    <th className="text-center text-info">Permisos</th>
                    <th className="text-center">Feriados</th>
                    <th className="text-center">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {resumen.length === 0
                    ? <tr><td colSpan={9} className="text-center py-4 text-muted">
                        No hay datos para este período.
                      </td></tr>
                    : resumen.map(r => (
                      <tr key={r.empleado_id}>
                        <td><code>{r.codigo}</code></td>
                        <td className="fw-semibold">{r.empleado_nombre}</td>
                        <td><small className="text-muted">{r.cargo}</small></td>
                        <td className="text-center">
                          <span className="badge bg-success">{r.normales}</span>
                        </td>
                        <td className="text-center">
                          <span className="badge bg-warning text-dark">{r.tardanzas}</span>
                        </td>
                        <td className="text-center">
                          <span className="badge bg-danger">{r.faltas}</span>
                        </td>
                        <td className="text-center">
                          <span className="badge bg-info">{r.permisos}</span>
                        </td>
                        <td className="text-center">
                          <span className="badge bg-secondary">{r.feriados}</span>
                        </td>
                        <td className="text-center fw-bold">{r.total_dias}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}